import React from 'react';
import AppInputText from '../../ui/AppInputText';
import Grid from '@material-ui/core/Grid';
import AppToast from '../../ui/AppToast';
import Api from '../../helpers/Api';
import Env from '../../config/env';
import ValidateForm from '../../helpers/ValidateForm';
import GetDataApi from '../../helpers/GetDataApi';
// import Session from '../../helpers/Session';
import Redirect from '../../helpers/Redirect';
import { withRouter } from 'react-router';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import AppInputNumber from '../../ui/AppInputNumber';
// import AppInputTel from "../../ui/AppInputTel";
// import AppInputCel from "../../ui/AppInputCel";
import MenuItem from '@material-ui/core/MenuItem';
import Alert from '@material-ui/lab/Alert';
import Dialog from '@material-ui/core/Dialog';
import ValidateSizeFile from '../../helpers/ValidateSizeFile';
import { getFileExtension } from '../../helpers/Helpers';
import GeneracionDireccion from '../cuenta-nueva/GenerarDireccion';
import AppBreadcrumbs from '../../components/AppBreadcrumbs';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import AppInputDate from '../../ui/AppInputDate';
import Session from '../../helpers/Session';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import '../../styles/File.css';
import ValidateEmail from '../../helpers/ValidateEmail';
import PDFIcon from '../../assets/IconPDF.png';


class InscripcionProveedores extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        tipoPersona: {
          key: 'tipoPersona',
          value: '',
          required: true,
          disabled: false,
        },
        nomtipoPersona: {
          key: 'nomtipoPersona',
          value: Env.nomTipoJuridico,
        },

        tipoDocumento: {
          key: 'tipoDocumento',
          value: '',
          required: true,
          disabled: false,
        },
        numeroDocumento: {
          key: 'numeroDocumento',
          value: '',
          required: true,
          disabled: false,
        },
        digitoVerificacion: {
          key: 'digitoVerificacion',
          value: '',
          required: true,
          disabled: false,
        },
        razonSocial: {
          key: 'razonSocial',
          value: '',
          required: true,
          disabled: false,
          label: Env.nomPersonaJuridico,
        },
        // primerNombre: {
        //     key: 'primerNombre',
        //     value: '',
        //     required: false,
        //     disabled: false,
        // },
        // segundoNombre: {
        //     key: 'segundoNombre',
        //     value: '',
        //     required: false,
        //     disabled: false,
        // },
        // primerApellido: {
        //     key: 'primerApellido',
        //     value: '',
        //     required: false,
        //     disabled: false,
        // },
        // segundoApellido: {
        //     key: 'segundoApellido',
        //     value: '',
        //     required: false,
        //     disabled: false,
        // },
        email: {
          key: 'email',
          value: '',
          required: true,
          disabled: false,
        },
        telefono: {
          key: 'telefono',
          value: '',
          required: false,
          disabled: false,
        },
        celular: {
          key: 'celular',
          value: '',
          required: true,
          disabled: false,
        },
        direccion: {
          key: 'direccion',
          value: '',
          required: true,
          disabled: false,
        },
        departamento: {
          key: 'departamento',
          value: '',
          required: false,
          disabled: false,
        },
        municipio: {
          key: 'municipio',
          value: '',
          required: false,
          disabled: false,
        },
        sucursal: {
          key: 'sucursal',
          value: '',
          required: false,
          disabled: false,
        },
        escritura: {
          key: 'escritura',
          value: '',
          required: false,
          disabled: false,
          label: Env.nomEscrituraJuridico,
        },
        fechaConstitucion: {
          key: 'fechaConstitucion',
          value: '',
          required: false,
          disabled: false,
          display: '',
        },
        emailSociedad: {
          key: 'emailSociedad',
          value: '',
          required: false,
          disabled: false,
          display: '',
        },
        notaria: {
          key: 'notaria',
          value: '',
          required: false,
          disabled: false,
          display: '',
        },
        departamentoSociedad: {
          key: 'departamentoSociedad',
          value: '',
          required: false,
          disabled: false,
          display: '',
        },
        municipioSociedad: {
          key: 'municipioSociedad',
          value: '',
          required: false,
          disabled: false,
          display: '',
        },
        numeroDocumentoSociedad: {
          key: 'numeroDocumentoSociedad',
          value: '',
          required: false,
          disabled: false,
          display: '',
        },
        tipoDocumentoSociedad: {
          key: 'tipoDocumentoSociedad',
          value: '',
          required: false,
          disabled: false,
          display: '',
        },
        representanteLegal: {
          key: 'representanteLegal',
          value: '',
          required: false,
          disabled: false,
          label: Env.nomRepreLegalJuridico,
        },
        actividadEconomica_1: {
          key: 'actividadEconomica_1',
          value: '',
          required: true,
          disabled: false,
        },
        actividadEconomica_2: {
          key: 'actividadEconomica_2',
          value: '',
          required: false,
          disabled: false,
        },
        actividadEconomica_3: {
          key: 'actividadEconomica_3',
          value: '',
          required: false,
          disabled: false,
        },
        actividadEconomica_4: {
          key: 'actividadEconomica_4',
          value: '',
          required: false,
          disabled: false,
        },
        proveedorBienes: {
          key: 'proveedorBienes',
          value: '',
          required: false,
          disabled: false,
        },
        proveedorServicios: {
          key: 'proveedorServicios',
          value: '',
          required: false,
          disabled: false,
        },
      },
      url: '',
      validateDocumentTypes: false,
      currentKey: '',
      openDialog: false,
      loadData: {
        documentTypes: [],
        departamento: [],
        departamentoSelect: null,
        departamentoSoiedadSelect: null,
        municipios: [],
        municipiosSociedad: [],
        files: [],
        validationFile: [],
      },
      fileCartaPresentacion: null,
      fileRegistroMercantil: null,
      fileRUT: null,
      fileCedula: null,
      fileNaturalVinculacionPDF: null,
      fileNaturalVinculacionEXCEL: null,
      fileJuridicaVinculacionPDF: null,
      fileJuridicaVinculacionEXCEL: null,
      fileIntegridadPDF: null,
      fileIntegridadEXCEL: null,
      user: null,
      proveedorBienes: false,
      proveedorServicios: false,
      files: [],
      validationFile: [],
      noMayor: 'Fecha de generación no mayor a ' + Env.mayorDateFiles + ' días.',
      noMayor2: 'Fecha de generación no mayor a ' + Env.mayorDateFiles2 + ' días.',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setDireccion = this.setDireccion.bind(this);
  }

  async componentDidMount() {
    this.loadForm();
  }

  loadForm = async () => {
    await this.getDocumentTypes();
    await this.getDepartamento();
    await this.getFiles();

    const userData = Session.getLogin();

    this.setState({
      ...this.state,
      form: {
        ...this.state.form,
        email: {
          ...this.state.form.email,
          value: userData.terceroMail,
          disabled: true,
        },
        /* emailSociedad: {
                    ...this.state.form.emailSociedad,
                    value: userData.terceroMail,
                    // disabled: true,
                },*/
      },
      user: userData,
    });

    await this.actualizar();
  };

  actualizar = async () => {
    if (this.props.inscripcion?.radicado) {
      this.state.form.tipoPersona.value = this.props.inscripcion?.tipoPersona;
      this.state.form.tipoDocumento.value = this.props.inscripcion?.tipoDocumento;
      this.state.form.numeroDocumento.value = this.props.inscripcion?.numeroDocumento;
      this.state.form.digitoVerificacion.value = this.props.inscripcion?.digitoVerificacion;
      this.state.form.razonSocial.value = this.props.inscripcion?.razonSocial;
      this.state.form.email.value = this.props.inscripcion?.email;
      this.state.form.telefono.value = this.props.inscripcion?.telefono ? this.props.inscripcion?.telefono : '';
      this.state.form.celular.value = this.props.inscripcion?.celular;
      this.state.form.direccion.value = this.props.inscripcion?.direccion;

      this.state.form.sucursal.value = this.props.inscripcion?.sucursal ? this.props.inscripcion?.sucursal : '';
      this.state.form.escritura.value = this.props.inscripcion?.escritura ? this.props.inscripcion?.escritura : '';
      this.state.form.fechaConstitucion.value = this.props.inscripcion?.fechaConstitucion ? this.props.inscripcion?.fechaConstitucion : '';
      this.state.form.emailSociedad.value = this.props.inscripcion?.emailSociedad ? this.props.inscripcion?.emailSociedad : '';
      this.state.form.notaria.value = this.props.inscripcion?.notaria ? this.props.inscripcion?.notaria : '';

      this.state.form.tipoDocumentoSociedad.value = this.props.inscripcion?.tipoDocumentoSociedad ? this.props.inscripcion?.tipoDocumentoSociedad : '';
      this.state.form.numeroDocumentoSociedad.value = this.props.inscripcion?.numeroDocumentoSociedad ? this.props.inscripcion?.numeroDocumentoSociedad : '';
      this.state.form.representanteLegal.value = this.props.inscripcion?.representanteLegal ? this.props.inscripcion?.representanteLegal : '';

      this.state.proveedorBienes = this.props.inscripcion?.proveedorBienes === '1' ? true : false;
      this.state.proveedorServicios = this.props.inscripcion?.proveedorServicios === '1' ? true : false;

      let dataActividad = JSON.parse(this.props.inscripcion?.actividadEconomica);

      if (dataActividad.length !== 0) {
        this.state.form.actividadEconomica_1.value = dataActividad[1] === null ? '' : dataActividad[1];
        this.state.form.actividadEconomica_2.value = dataActividad[2] === null ? '' : dataActividad[2];
        this.state.form.actividadEconomica_3.value = dataActividad[3] === null ? '' : dataActividad[3];
        this.state.form.actividadEconomica_3.value = dataActividad[4] === null ? '' : dataActividad[4];
      }
      // console.log()

      // for (let value of dataActividad) {
      //     console.log(value)
      // }

      this.state.form.departamento.value = this.props.inscripcion?.departamento;
      this.state.loadData.departamentoSelect = this.props.inscripcion?.departamento;

      await this.getCities();

      this.state.form.departamentoSociedad.value = this.props.inscripcion?.departamentoSociedad;
      this.state.loadData.departamentoSoiedadSelect = this.props.inscripcion?.departamentoSociedad;

      await this.getCitiesSociedad();

      // this.state.form.actividadEconomica.value        = ;
      // this.state.form.fileCartaPresentacion.value     = this.props.inscripcion?.fileCartaPresentacion;
      // this.state.form.fileRegistroMercantil.value     = this.props.inscripcion?.fileRegistroMercantil;
      // this.state.form.fileRUT.value                   = this.props.inscripcion?.fileRUT;
      // this.state.form.fileCedula.value                = this.props.inscripcion?.fileCedula;
      // this.state.form.estado.value                    = this.props.inscripcion?.estado;
      // this.state.form.fechaCreacion.value             = this.props.inscripcion?.fechaCreacion;
      // this.state.form.estado.value                    = this.props.inscripcion?.estado;
      // this.state.form.gestion.value                   = this.props.inscripcion?.gestion;
      console.log('municipio');
      this.state.form.municipioSociedad.value = this.props.inscripcion?.municipioSociedad;
      this.state.form.municipio.value = this.props.inscripcion?.municipio;
    }
  };

  getCities = async () => {
    const departamentoID = this.state.loadData.departamentoSelect === null ? 0 : this.state.loadData.departamentoSelect;
    const data = await Api.get(`${Env.UrlBackend}/get-municipios-vista/${departamentoID}`);
    if (!data.success) {
      AppToast(data.message, false);
    } else {
      console.log('aaaaaa');
    }
    this.setState({
      loadData: {
        ...this.state.loadData,
        municipios: data.data,
      },
    });
  };

  getFiles = async () => {
    const data = await Api.get(`${Env.UrlBackend}/provider-registration/archivos`);
    if (!data.success) {
      AppToast(data.message, false);
    } else {
      this.setState({
        loadData: {
          ...this.state.loadData,
          files: data.data,
        },
      });
    }
  };

  getCitiesSociedad = async () => {
    const departamentoID = this.state.loadData.departamentoSoiedadSelect === null ? 0 : this.state.loadData.departamentoSoiedadSelect;
    const data = await Api.get(`${Env.UrlBackend}/get-municipios-vista/${departamentoID}`);
    if (!data.success) {
      AppToast(data.message, false);
    }
    this.setState({
      loadData: {
        ...this.state.loadData,
        municipiosSociedad: data.data,
      },
    });
  };

  getDepartamento = async () => {
    const data = await Api.get(`${Env.UrlBackend}/get-departamentos`);
    if (!data.success) {
      AppToast(data.message, false);
    }
    this.setState({
      loadData: {
        ...this.state.loadData,
        departamento: data.data,
      },
    });
  };

  getDocumentTypes = async () => {
    const data = await Api.get(`${Env.UrlSeguridad}/getDocumentoTipo`);
    if (data.cod === '1') {
      this.setState({
        loadData: {
          ...this.state.loadData,
          documentTypes: data.DocumentoTipo,
        },
      });
    } else {
      AppToast(data.message, false);
    }
  };

  changelabelSociedad = async (tipo) => {
    if (tipo === 1) {
      this.state.form.nomtipoPersona.value = Env.nomTipoNatural;
      this.state.form.escritura.label = Env.nomEscrituraNatural;
      this.state.form.fechaConstitucion.display = 'none';
      this.state.form.emailSociedad.display = 'none';
      this.state.form.notaria.display = 'none';
      this.state.form.departamentoSociedad.display = 'none';
      this.state.form.municipioSociedad.display = 'none';
      this.state.form.tipoDocumentoSociedad.display = 'none';
      this.state.form.numeroDocumentoSociedad.display = 'none';
      this.state.form.razonSocial.label = Env.nomPersonaNatural;
      this.state.form.representanteLegal.label = Env.nomEstableComercioNatural;
      this.state.form.escritura.required = false;
      this.state.form.fechaConstitucion.required = false;
      this.state.form.emailSociedad.required = false;
      this.state.form.notaria.required = false;
      this.state.form.departamentoSociedad.required = false;
      this.state.form.municipioSociedad.required = false;
      this.state.form.tipoDocumentoSociedad.required = false;
      this.state.form.numeroDocumentoSociedad.required = false;
      this.state.form.representanteLegal.required = false;
      this.state.form.emailSociedad.value = '';
    } else {
      this.state.form.nomtipoPersona.value = Env.nomTipoJuridico;
      this.state.form.escritura.label = Env.nomEscrituraJuridico;
      this.state.form.fechaConstitucion.display = '';
      this.state.form.emailSociedad.display = '';
      this.state.form.notaria.display = '';
      this.state.form.departamentoSociedad.display = '';
      this.state.form.municipioSociedad.display = '';
      this.state.form.tipoDocumentoSociedad.display = '';
      this.state.form.numeroDocumentoSociedad.display = '';
      this.state.form.razonSocial.label = Env.nomPersonaJuridico;
      this.state.form.representanteLegal.label = Env.nomRepreLegalJuridico;
      this.state.form.escritura.required = true;
      this.state.form.fechaConstitucion.required = true;
      this.state.form.emailSociedad.required = true;
      this.state.form.notaria.required = true;
      this.state.form.departamentoSociedad.required = true;
      this.state.form.municipioSociedad.required = true;
      this.state.form.tipoDocumentoSociedad.required = true;
      this.state.form.numeroDocumentoSociedad.required = true;
      this.state.form.representanteLegal.required = true;
      this.state.form.emailSociedad.value = this.state.form.email.value;
    }
  };
  handleChange = async (e) => {
    const { value, name } = e.target;

    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          [name]: {
            ...statePrev.form[name],
            value: value,
          },
        },
      };
    });

    switch (name) {
      case this.state.form.tipoDocumento.key:
        this.state.validateDocumentTypes = value === '31' ? true : false;
        // this.state.form.primerNombre.value = ''
        // this.state.form.segundoNombre.value = ''
        // this.state.form.primerApellido.value = ''
        // this.state.form.segundoApellido.value = ''
        // this.state.form.razonSocial.value = ''
        break;
      case this.state.form.departamento.key:
        this.state.loadData.departamentoSelect = value;
        if (this.state.form.tipoPersona.value !== 1) {
          this.state.loadData.departamentoSoiedadSelect = value;
          this.state.form.departamentoSociedad.value = value;
        }
        await this.getCities();
        await this.getCitiesSociedad();
        break;
      case this.state.form.departamentoSociedad.key:
        this.state.loadData.departamentoSoiedadSelect = value;
        await this.getCitiesSociedad();
        break;
      // case this.state.form.primerNombre.key:
      //     break;
      case this.state.form.municipio.key:
        if (this.state.form.tipoPersona.value !== 1) {
          this.state.form.municipioSociedad.value = value;
        }
        break;
      case this.state.form.tipoPersona.key:
        await this.changelabelSociedad(value);
        break;
      default:
        break;
    }

    //if(name===this.state.form.tipoDocumento.key && value==='31'){
    // this.state.form.primerNombre.required = false;
    // this.state.form.segundoNombre.required = false;
    // this.state.form.primerApellido.required = false;
    // this.state.form.segundoApellido.required = false;

    // this.state.form.razonSocial.required = true;

    /*this.state.form.escritura.required = true;
            this.state.form.fechaConstitucion.required = true;
            this.state.form.emailSociedad.required = true;
            this.state.form.notaria.required = true;
            this.state.form.departamentoSociedad.required = true;
            this.state.form.municipioSociedad.required = true;
            this.state.form.tipoDocumentoSociedad.required = true;
            this.state.form.numeroDocumentoSociedad.required = true;
            this.state.form.representanteLegal.required = true;

        }else if(name===this.state.form.tipoDocumento.key && value!=='31'){
            // this.state.form.primerNombre.required = true;
            // this.state.form.segundoNombre.required = false;
            // this.state.form.primerApellido.required = true;
            // this.state.form.segundoApellido.required = true;

            // this.state.form.razonSocial.required = false;

            this.state.form.escritura.required = false;
            this.state.form.fechaConstitucion.required = false;
            this.state.form.emailSociedad.required = false;
            this.state.form.notaria.required = false;
            this.state.form.departamentoSociedad.required = false;
            this.state.form.municipioSociedad.required = false;
            this.state.form.tipoDocumentoSociedad.required = false;
            this.state.form.numeroDocumentoSociedad.required = false;
            this.state.form.representanteLegal.required = false;
        }*/
  };

  handleProveedor = () => {
    if (this.state.proveedorBienes === true) {
      this.setState({ proveedorBienes: false });
    } else {
      this.setState({ proveedorBienes: true });
    }
  };

  handleServicio = () => {
    if (this.state.proveedorServicios === true) {
      this.setState({ proveedorServicios: false });
    } else {
      this.setState({ proveedorServicios: true });
    }
  };

  keyPress = async (e, tipoEvento = 'keyPress') => {
    if (e.keyCode === 13 || tipoEvento === 'onBlur') {
      e.preventDefault();
    }
  };

  openDialogDireccion = (name) => {
    this.setState({
      openDialog: true,
      currentKey: name,
    });
  };

  setDireccion = (name, value) => {
    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          [name]: {
            ...statePrev.form[name],
            value: value,
          },
        },
      };
    });
  };

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
    });
  };

  getFormData = (params) => {
    let formData = new FormData();
    for (const name in params) {
      formData.append(name, params[name]);
    }
    return formData;
  };

  handleChangeFiles = (e, tipo, extension) => {
    const selectorFiles = e.target.files;
    let file = null;
    if (selectorFiles.length > 0) {
      file = selectorFiles[0];
    }

    if (!ValidateSizeFile(file)) {
      AppToast(`El tamaño permitido es de ${Env.AllowedSize} megas`, false);
      this.setState({
        [tipo]: null,
      });
      e.target.value = '';
      return false;
    }

    const fileExtension = getFileExtension(file.name);
    if (fileExtension !== extension) {
      AppToast(`El archivo adjunto debe ser un .` + extension, false);
      this.setState({
        [tipo]: null,
      });
      e.target.value = '';
      return false;
    }

    this.setState({
      [tipo]: file,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones del formulario
    if (!this.validate()) {
      return;
    }

    // let paramsDocumento = {
    //     cartaPresentacion : {
    //         url: this.state.fileCartaPresentacion,
    //         nombre: 'carta-presentacion',
    //         extension: 'pdf',
    //         codigo: 1,
    //         estado: 1
    //     },
    //     RUT : {
    //         url: this.state.fileRUT,
    //         nombre: 'rut',
    //         extension: 'pdf',
    //         codigo: 4,
    //         estado: 1
    //     },
    //     cedula : {
    //         url: this.state.fileCedula,
    //         nombre: 'cedula',
    //         extension: 'pdf',
    //         codigo: 5,
    //         estado: 1
    //     },
    //     integridadPDF : {
    //         url: this.state.fileIntegridadPDF,
    //         nombre: 'integridad-pdf',
    //         extension: 'pdf',
    //         codigo: 10,
    //         estado: 1
    //     },
    //     integridadEXCEL : {
    //         url: this.state.fileIntegridadEXCEL,
    //         nombre: 'integridad-excel',
    //         extension: 'xlsx',
    //         codigo: 2,
    //         estado: 11
    //     },
    // }

    // if(this.state.form.tipoPersona.value!==1){
    //     paramsDocumento = {
    //         ... paramsDocumento,
    //         vinculacionPDF: {
    //             url: this.state.fileJuridicaVinculacionPDF,
    //             nombre: 'vinculacion-pdf',
    //             extension: 'pdf',
    //             codigo: 6,
    //             estado: 1
    //         },
    //         vinculacionEXCEL: {
    //             url: this.state.fileJuridicaVinculacionEXCEL,
    //             nombre: 'vinculacion-excel',
    //             extension: 'xlsx',
    //             codigo: 7,
    //             estado: 1
    //         },
    //         registroMercantil : {
    //             url: this.state.fileRegistroMercantil,
    //             nombre: 'registro-mercantil',
    //             extension: 'pdf',
    //             codigo: 3,
    //             estado: 1
    //         },
    //     }
    // }else if(this.state.form.tipoPersona.value===1){
    //     paramsDocumento = {
    //         ... paramsDocumento,
    //         vinculacionNaturalPDF: {
    //             url: this.state.fileNaturalVinculacionPDF,
    //             nombre: 'vinculacion-pdf',
    //             extension: 'pdf',
    //             codigo: 8,
    //             estado: 1
    //         },
    //         vinculacionNaturalEXCEL: {
    //             url: this.state.fileNaturalVinculacionEXCEL,
    //             nombre: 'vinculacion-excel',
    //             extension: 'xlsx',
    //             codigo: 9,
    //             estado: 1
    //         }
    //     }
    // }

    let fileVinculacionPDF_ = '';
    let fileVinculacionEXCEL_ = '';
    if (this.state.form.tipoPersona.value !== 1) {
      fileVinculacionPDF_ = this.state.fileJuridicaVinculacionPDF;
      fileVinculacionEXCEL_ = this.state.fileJuridicaVinculacionEXCEL;
    } else if (this.state.form.tipoPersona.value === 1) {
      fileVinculacionPDF_ = this.state.fileNaturalVinculacionPDF;
      fileVinculacionEXCEL_ = this.state.fileNaturalVinculacionEXCEL;
    }

    let params = GetDataApi(this.state.form);

    console.log(this.state.fileCartaPresentacion);

    // console.log('json',JSON.stringify(paramsDocumento))
    // console.log('paramsDocumento',paramsDocumento)

    params = {
      ...params,
      fileCartaPresentacion_: this.state.fileCartaPresentacion,
      fileRegistroMercantil_: this.state.fileRegistroMercantil,
      fileRUT_: this.state.fileRUT,
      fileCedula_: this.state.fileCedula,
      fileIntegridadPDF_: this.state.fileIntegridadPDF,
      fileIntegridadEXCEL_: this.state.fileIntegridadEXCEL,
      fileVinculacionPDF_: fileVinculacionPDF_,
      fileVinculacionEXCEL_: fileVinculacionEXCEL_,
      user: this.state.user.terceroID,
      proveedorBienes: this.state.proveedorBienes ? 1 : 0,
      proveedorServicios: this.state.proveedorServicios ? 1 : 0,
      // documentos: paramsDocumento,
      // documentos_old: JSON.stringify(paramsDocumento),
    };

    console.log('params', params);

    const formData = this.getFormData(params);

    const data = await Api.postWithoutFormData(`${Env.UrlBackend}/provider-registration/radicar`, formData);
    if (data.success) {
      AppToast(data.message, true);

      this.setState({
        url: '/provider-registration-list',
      });
    } else {
      data.message.map((item) => {
        AppToast(item, false);

        return item;
      });
    }
  };

  validate = () => {
    // Valida los campos obligatorios
    if (!ValidateForm(this.state.form)) {
      return false;
    }

    if (this.state.proveedorBienes === false && this.state.proveedorServicios === false) {
      AppToast('Debe seleccionar tipo proveedor.', false);
      return false;
    }

    if (!this.state.fileCartaPresentacion) {
      AppToast('Debe adjuntar el documento carta de presentación.', false);
      return false;
    }

    if (!this.state.fileRUT) {
      AppToast('Debe adjuntar el documento RUT.', false);
      return false;
    }

    if (!this.state.fileCedula) {
      AppToast('Debe adjuntar el documento cedula.', false);
      return false;
    }

    // Valida formato del email
    if (this.state.form.emailSociedad.value) {
      if (!ValidateEmail(this.state.form.emailSociedad.value)) {
        AppToast('El email no tiene un formato válido!', false);
        return false;
      }
    }

    if (this.state.form.tipoPersona.value !== 1) {
      if (!this.state.fileRegistroMercantil) {
        AppToast('Debe adjuntar el documento registro mercantil.', false);
        return false;
      }

      /*if (!this.state.fileJuridicaVinculacionPDF) {
        AppToast('Debe adjuntar el documento vinculación (PDF).', false);
        return false;
      }*/

      /* if (!this.state.fileJuridicaVinculacionEXCEL) {
        AppToast('Debe adjuntar el documento vinculación (EXCEL).', false);
        return false;
      }*/
    } else {
      /*if (!this.state.fileNaturalVinculacionPDF) {
        AppToast('Debe adjuntar el documento de vinculación (PDF).', false);
        return false;
      }*/
      /*if (!this.state.fileNaturalVinculacionEXCEL) {
        AppToast('Debe adjuntar el documento de vinculación (EXCEL).', false);
        return false;
      }*/
    }

    /*if (!this.state.fileIntegridadPDF) {
      AppToast('Debe adjuntar el documento de integridad (PDF).', false);
      return false;
    }

    if (!this.state.fileIntegridadEXCEL) {
      AppToast('Debe adjuntar el documento de integridad (EXCEL).', false);
      return false;
    }*/

    return true;
  };

  onChangeFile(e) {
    var files = e.target.files;
    console.log(files);
    var filesArr = Array.prototype.slice.call(files);
    console.log(filesArr);
    this.setState({ files: [...this.state.files, ...filesArr] });
  }

  removeFile(f) {
    //    this.setState({ files: this.state.files.filter(x => x !== f) });
  }

  render() {
    const { inscripcion } = this.props;

    return (
      <div style={{ minHeight: '500px', textAlign: 'center' }}>
        <Redirect url={this.state.url} />

        {inscripcion?.radicado !== undefined ? (
          ''
        ) : (
          <AppBreadcrumbs
            links={[
              {
                url: 'accounts',
                label: 'Cuentas',
              },
              {
                url: 'provider-registration-list',
                label: 'Inscripción de proveedores',
              },
            ]}
            actual="Radicar"
          />
        )}

        <div style={{ padding: '20px', width: '65%', margin: 'auto', backgroundColor: '#FFF' }}>
          <form onSubmit={this.handleSubmit}>
            <Grid container direction="column" justify="flex-start" alignItems="center">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <h2 style={{ textAlign: 'center' }}>
                    <span>INSCRIPCIÓN DE PROVEEDORES</span>
                  </h2>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <h4 style={{ textAlign: 'left' }}>1. DATOS GENERALES</h4>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl required variant="outlined" style={{ width: '100%' }}>
                    <InputLabel id="demo-simple-select-outlined-label">Tipo Persona</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id={this.state.form.tipoPersona.key}
                      name={this.state.form.tipoPersona.key}
                      value={this.state.form.tipoPersona.value}
                      disabled={this.state.form.tipoPersona.disabled}
                      onChange={this.handleChange}
                      label="Tipo Persona"
                      required={this.state.form.tipoPersona.required}
                      variant="outlined"
                    >
                      <MenuItem key={1} value={1}>
                        Natural
                      </MenuItem>
                      <MenuItem key={0} value={0}>
                        Jurídica
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl required variant="outlined" style={{ width: '100%' }}>
                    <InputLabel id="demo-simple-select-outlined-label">Tipo Documento</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id={this.state.form.tipoDocumento.key}
                      name={this.state.form.tipoDocumento.key}
                      value={this.state.form.tipoDocumento.value}
                      disabled={this.state.form.tipoDocumento.disabled}
                      onChange={this.handleChange}
                      label="Tipo Documento"
                      required={this.state.form.tipoDocumento.required}
                      variant="outlined"
                    >
                      {this.state.loadData.documentTypes.map((val, index) => {
                        return (
                          <MenuItem key={index} value={val.documentoTipoID}>
                            {val.documentoTipoDescripcion}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <AppInputText
                    id={this.state.form.numeroDocumento.key}
                    name={this.state.form.numeroDocumento.key}
                    value={this.state.form.numeroDocumento.value}
                    disabled={this.state.form.numeroDocumento.disabled}
                    label="Número de documento"
                    onChange={this.handleChange}
                    required={this.state.form.numeroDocumento.required}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <AppInputNumber
                    id={this.state.form.digitoVerificacion.key}
                    name={this.state.form.digitoVerificacion.key}
                    value={this.state.form.digitoVerificacion.value}
                    disabled={this.state.form.digitoVerificacion.disabled}
                    label="DV"
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={(e) => {
                      this.keyPress(e, 'onBlur');
                    }}
                    required={this.state.form.digitoVerificacion.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AppInputText
                    id={this.state.form.razonSocial.key}
                    name={this.state.form.razonSocial.key}
                    value={this.state.form.razonSocial.value}
                    disabled={this.state.form.razonSocial.disabled}
                    label={this.state.form.razonSocial.label}
                    onChange={this.handleChange}
                    required={this.state.form.razonSocial.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AppInputText
                    id={this.state.form.email.key}
                    name={this.state.form.email.key}
                    value={this.state.form.email.value}
                    disabled={this.state.form.email.disabled}
                    label="Email"
                    onChange={this.handleChange}
                    required={this.state.form.email.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AppInputNumber
                    id={this.state.form.telefono.key}
                    name={this.state.form.telefono.key}
                    value={this.state.form.telefono.value}
                    disabled={this.state.form.telefono.disabled}
                    label="Telefono"
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={(e) => {
                      this.keyPress(e, 'onBlur');
                    }}
                    required={this.state.form.telefono.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AppInputNumber
                    id={this.state.form.celular.key}
                    name={this.state.form.celular.key}
                    value={this.state.form.celular.value}
                    disabled={this.state.form.celular.disabled}
                    label="Celular"
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={(e) => {
                      this.keyPress(e, 'onBlur');
                    }}
                    required={this.state.form.celular.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AppInputText
                    id={this.state.form.direccion.key}
                    name={this.state.form.direccion.key}
                    value={this.state.form.direccion.value}
                    disabled={this.state.form.direccion.disabled}
                    label="Dirección"
                    onChange={this.handleChange}
                    readonly={true}
                    onclick={() => {
                      this.openDialogDireccion(this.state.form.direccion.key);
                    }}
                    required={this.state.form.direccion.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AppInputNumber
                    id={this.state.form.sucursal.key}
                    name={this.state.form.sucursal.key}
                    value={this.state.form.sucursal.value}
                    disabled={this.state.form.sucursal.disabled}
                    label="Sucursales o agencias"
                    onChange={this.handleChange}
                    required={this.state.form.sucursal.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl required variant="outlined" style={{ width: '100%' }}>
                    <InputLabel id="demo-simple-select-outlined-label">Departamento</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id={this.state.form.departamento.key}
                      name={this.state.form.departamento.key}
                      value={this.state.form.departamento.value}
                      onChange={this.handleChange}
                      label="Departamento"
                      required={true}
                      variant="outlined"
                    >
                      {this.state.loadData.departamento.map((val, index) => {
                        return (
                          <MenuItem key={index} value={val.codigo}>
                            {val.nombre}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl required variant="outlined" style={{ width: '100%' }}>
                    <InputLabel id="demo-simple-select-outlined-label">Municipio</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id={this.state.form.municipio.key}
                      name={this.state.form.municipio.key}
                      value={this.state.form.municipio.value}
                      onChange={this.handleChange}
                      label="Municipio"
                      required={true}
                      variant="outlined"
                    >
                      {this.state.loadData.municipios.map((val, index) => {
                        return (
                          <MenuItem key={index} value={val.codigo}>
                            {val.nombre}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <h4 style={{ textAlign: 'left' }}>2. {this.state.form.nomtipoPersona.value}</h4>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AppInputNumber
                    id={this.state.form.escritura.key}
                    name={this.state.form.escritura.key}
                    value={this.state.form.escritura.value}
                    disabled={this.state.form.escritura.disabled}
                    label={this.state.form.escritura.label}
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={(e) => {
                      this.keyPress(e, 'onBlur');
                    }}
                    required={this.state.form.escritura.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6} style={{ display: this.state.form.fechaConstitucion.display }}>
                  <AppInputDate
                    id={this.state.form.fechaConstitucion.key}
                    name={this.state.form.fechaConstitucion.key}
                    value={this.state.form.fechaConstitucion.value}
                    disabled={this.state.form.fechaConstitucion.disabled}
                    label="Fecha de constitución"
                    onChange={this.handleChange}
                    required={this.state.form.fechaConstitucion.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6} style={{ display: this.state.form.emailSociedad.display }}>
                  <AppInputText
                    id={this.state.form.emailSociedad.key}
                    name={this.state.form.emailSociedad.key}
                    value={this.state.form.emailSociedad.value}
                    disabled={this.state.form.emailSociedad.disabled}
                    label="Email"
                    onChange={this.handleChange}
                    required={this.state.form.emailSociedad.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6} style={{ display: this.state.form.notaria.display }}>
                  <AppInputText
                    id={this.state.form.notaria.key}
                    name={this.state.form.notaria.key}
                    value={this.state.form.notaria.value}
                    disabled={this.state.form.notaria.disabled}
                    label="Notaria"
                    onChange={this.handleChange}
                    required={this.state.form.notaria.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6} style={{ display: this.state.form.departamentoSociedad.display }}>
                  <FormControl variant="outlined" style={{ width: '100%' }}>
                    <InputLabel id="demo-simple-select-outlined-label">Departamento</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id={this.state.form.departamentoSociedad.key}
                      name={this.state.form.departamentoSociedad.key}
                      value={this.state.form.departamentoSociedad.value}
                      onChange={this.handleChange}
                      label="Departamento"
                      required={this.state.form.departamentoSociedad.required}
                      variant="outlined"
                    >
                      {this.state.loadData.departamento.map((val, index) => {
                        return (
                          <MenuItem key={index} value={val.codigo}>
                            {val.nombre}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} style={{ display: this.state.form.municipioSociedad.display }}>
                  <FormControl variant="outlined" style={{ width: '100%' }}>
                    <InputLabel id="demo-simple-select-outlined-label">Municipio</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id={this.state.form.municipioSociedad.key}
                      name={this.state.form.municipioSociedad.key}
                      value={this.state.form.municipioSociedad.value}
                      onChange={this.handleChange}
                      label="Municipio"
                      required={this.state.form.municipioSociedad.required}
                      variant="outlined"
                    >
                      {this.state.loadData.municipiosSociedad.map((val, index) => {
                        return (
                          <MenuItem key={index} value={val.codigo}>
                            {val.nombre}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} style={{ display: this.state.form.tipoDocumentoSociedad.display }}>
                  <FormControl variant="outlined" style={{ width: '100%' }}>
                    <InputLabel id="demo-simple-select-outlined-label">Tipo Documento</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id={this.state.form.tipoDocumentoSociedad.key}
                      name={this.state.form.tipoDocumentoSociedad.key}
                      value={this.state.form.tipoDocumentoSociedad.value}
                      disabled={this.state.form.tipoDocumentoSociedad.disabled}
                      onChange={this.handleChange}
                      label="Tipo Documento"
                      required={this.state.form.tipoDocumentoSociedad.required}
                      variant="outlined"
                    >
                      {this.state.loadData.documentTypes.map((val, index) => {
                        return (
                          <MenuItem key={index} value={val.documentoTipoID}>
                            {val.documentoTipoDescripcion}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} style={{ display: this.state.form.numeroDocumentoSociedad.display }}>
                  <AppInputText
                    id={this.state.form.numeroDocumentoSociedad.key}
                    name={this.state.form.numeroDocumentoSociedad.key}
                    value={this.state.form.numeroDocumentoSociedad.value}
                    disabled={this.state.form.numeroDocumentoSociedad.disabled}
                    label="Número de documento"
                    onChange={this.handleChange}
                    required={this.state.form.numeroDocumentoSociedad.required}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AppInputText
                    id={this.state.form.representanteLegal.key}
                    name={this.state.form.representanteLegal.key}
                    value={this.state.form.representanteLegal.value}
                    disabled={this.state.form.representanteLegal.disabled}
                    label={this.state.form.representanteLegal.label}
                    onChange={this.handleChange}
                    required={this.state.form.representanteLegal.required}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <h4 style={{ textAlign: 'left' }}>3. TIPOS DE PROVEEDOR</h4>
                </Grid>
                <Grid item xs={12} sm={6} style={{ textAlign: 'left' }}>
                  <span onClick={this.handleProveedor}>
                    <FormControlLabel control={<Checkbox readOnly={true} checked={this.state.proveedorBienes} />} label="" />
                    Proveedor de bienes
                  </span>
                  <br />
                  <span onClick={this.handleServicio}>
                    <FormControlLabel control={<Checkbox readOnly={true} checked={this.state.proveedorServicios} />} label="" />
                    Proveedor de servicios
                  </span>
                </Grid>
                <Grid item xs={12} sm={6}></Grid>
                <Grid item xs={12} sm={3}>
                  <AppInputNumber
                    id={this.state.form.actividadEconomica_1.key}
                    name={this.state.form.actividadEconomica_1.key}
                    value={this.state.form.actividadEconomica_1.value}
                    disabled={this.state.form.actividadEconomica_1.disabled}
                    label="Actividad económica"
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={(e) => {
                      this.keyPress(e, 'onBlur');
                    }}
                    required={this.state.form.actividadEconomica_1.required}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AppInputNumber
                    id={this.state.form.actividadEconomica_2.key}
                    name={this.state.form.actividadEconomica_2.key}
                    value={this.state.form.actividadEconomica_2.value}
                    disabled={this.state.form.actividadEconomica_2.disabled}
                    label="Actividad económica"
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={(e) => {
                      this.keyPress(e, 'onBlur');
                    }}
                    required={this.state.form.actividadEconomica_2.required}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AppInputNumber
                    id={this.state.form.actividadEconomica_3.key}
                    name={this.state.form.actividadEconomica_3.key}
                    value={this.state.form.actividadEconomica_3.value}
                    disabled={this.state.form.actividadEconomica_3.disabled}
                    label="Actividad económica"
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={(e) => {
                      this.keyPress(e, 'onBlur');
                    }}
                    required={this.state.form.actividadEconomica_3.required}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <AppInputNumber
                    id={this.state.form.actividadEconomica_4.key}
                    name={this.state.form.actividadEconomica_4.key}
                    value={this.state.form.actividadEconomica_4.value}
                    disabled={this.state.form.actividadEconomica_4.disabled}
                    label="Actividad económica"
                    onChange={this.handleChange}
                    onKeyDown={this.keyPress}
                    onBlur={(e) => {
                      this.keyPress(e, 'onBlur');
                    }}
                    required={this.state.form.actividadEconomica_4.required}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <h4 style={{ textAlign: 'left' }}>4. DOCUMENTOS QUE SE DEBEN ANEXAR A ESTE FORMULARIO</h4>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '5px',
                      marginBottom: '10px',
                      margin: 'auto',
                      textAlign: 'left',
                      padding: '5px',
                    }}
                  >
                    <label style={{ paddingLeft: '8px' }}>
                      Carta de presentación y portafolio de servicios.
                      <span className="file-obligatorio"> * </span>
                    </label>
                    <br />
                    <span style={{ padding: '6px' }}>
                      <img style={{ width: '20px' }} src={PDFIcon} alt="Logo PDF" />
                    </span>
                    <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileCartaPresentacion', 'pdf')} />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '5px',
                      marginBottom: '10px',
                      textAlign: 'left',
                      padding: '5px',
                    }}
                  >
                    <label style={{ paddingLeft: '8px' }}>
                      Certificado de inscripción en el registro mercantil o existencia y representación legal respectivamente.
                      <br />
                      <span style={{ fontWeight: 'bold', paddingLeft: '8px' }}>{this.state.noMayor}</span>
                      <span className="file-obligatorio">{this.state.form.tipoPersona.value !== 1 ? '*' : ''}</span>
                    </label>
                    <br />

                    <span style={{ padding: '6px' }}>
                      <img style={{ width: '20px' }} src={PDFIcon} alt="Logo PDF" />
                    </span>
                    <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileRegistroMercantil', 'pdf')} />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '5px',
                      marginBottom: '10px',
                      textAlign: 'left',
                      padding: '5px',
                    }}
                  >
                    <label style={{ paddingLeft: '8px' }}>
                      Fotocopia del Registro Único Tributario (RUT) actualizado.
                      <br />
                      <span style={{ fontWeight: 'bold', paddingLeft: '8px' }}>{this.state.noMayor2}</span>
                      <span className="file-obligatorio"> * </span>
                    </label>
                    <br />
                    <span style={{ padding: '6px' }}>
                      <img style={{ width: '20px' }} src={PDFIcon} alt="Logo PDF" />
                    </span>
                    <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileRUT', 'pdf')} />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '5px',
                      marginBottom: '10px',
                      textAlign: 'left',
                      padding: '5px',
                    }}
                  >
                    <label style={{ paddingLeft: '8px' }}>
                      Fotocopia de la cedula de ciudadanía del Representante Legal o de la Persona Natural.
                      <span className="file-obligatorio"> * </span>
                    </label>
                    <br />
                    <span style={{ padding: '6px' }}>
                      <img style={{ width: '20px' }} src={PDFIcon} alt="Logo PDF" />
                    </span>
                    <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileCedula', 'pdf')} />
                  </div>
                </Grid>
                {this.state.form.tipoPersona.value !== '' ? (
                  this.state.form.tipoPersona.value !== 1 ? (
                    <div></div>
                  ) : (
                    <div></div>
                    /*<Grid item xs={12} sm={12}>
                      <div
                        style={{
                          border: '1px solid #ccc',
                          borderRadius: '5px',
                          marginBottom: '10px',
                          textAlign: 'left',
                          padding: '5px',
                        }}
                      >
                        <label style={{ paddingLeft: '8px' }}>
                          Formulario vinculación de proveedores.
                          <span className="file-obligatorio"> * </span>
                        </label>
                        <br />
                        <span style={{ padding: '6px' }}>
                          <img style={{ width: '20px' }} src={PDFIcon} alt="Logo PDF" />
                        </span>
                        <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileJuridicaVinculacionPDF', 'pdf')} />
                        <br />
                        <span style={{ padding: '6px' }}>
                          <img style={{ width: '20px' }} src={ExcelIcon} alt="Logo Excel" />
                        </span>
                        <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileJuridicaVinculacionEXCEL', 'xlsx')} />

                        <Alert severity="info" style={{ textAlign: 'left' }}>
                          <span>
                            * Descargar Formato &nbsp;
                            <a rel="noopener noreferrer" href={Env.UrlFilesPublic + this.state.loadData.files.vinculacion_juridica} target="_blank">
                              aquí
                            </a>
                          </span>
                        </Alert>
                      </div>
                    </Grid>*/
                    /*<Grid item xs={12} sm={12}>
                                                    <div style={{
                                                        border: '1px solid #ccc',
                                                        borderRadius: '5px',
                                                        marginBottom: '10px',
                                                        textAlign: 'left',
                                                        padding: '5px'
                                                    }}>
                                                        <label style={{paddingLeft: '8px'}}>
                                                            Formulario vinculación de persona natural.
                                                            <span className='file-obligatorio'> * </span>
                                                        </label>
                                                        <br/>
                                                        <span style={{padding: '6px'}}>
                                                           <img style={{width: '20px'}} src={PDFIcon} alt='Logo PDF'/>
                                                        </span>
                                                        <input type="file"
                                                                style={{padding: '10px'}}
                                                                onChange={(e) => this.handleChangeFiles(e, 'fileNaturalVinculacionPDF', 'pdf')}/>
                                                        <br/>
                                                        <span style={{padding: '6px'}}>
                                                            <img style={{width: '20px'}} src={ExcelIcon} alt='Logo Excel'/>
                                                        </span>
                                                        <input type="file"
                                                                style={{padding: '10px'}}
                                                                onChange={(e) => this.handleChangeFiles(e, 'fileNaturalVinculacionEXCEL', 'xlsx')}/>

                                                        <Alert severity="info" style={{textAlign: 'left'}}>
                                                            <span>
                                                                * Descargar Formato &nbsp;
                                                                <a rel="noopener noreferrer"
                                                                    href={ Env.UrlFilesPublic + this.state.loadData.files.vinculacion_natural}
                                                                    target='_blank'>aquí</a>
                                                            </span>
                                                        </Alert>
                                                    </div>
                                                </Grid>*/
                  )
                ) : (
                  ''
                )}
                {/*<Grid item xs={12} sm={12}>
                  <div
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '5px',
                      marginBottom: '10px',
                      textAlign: 'left',
                      padding: '5px',
                    }}
                  >
                    <label style={{ paddingLeft: '8px' }}>
                      Compromiso con la integridad contractual.
                      <span className="file-obligatorio"> * </span>
                    </label>
                    <br />
                    <span style={{ padding: '6px' }}>
                      <img style={{ width: '20px' }} src={PDFIcon} alt="Logo PDF" />
                    </span>
                    <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileIntegridadPDF', 'pdf')} />
                    <br />
                    <span style={{ padding: '6px' }}>
                      <img style={{ width: '20px' }} src={ExcelIcon} alt="Logo Excel" />
                    </span>
                    <input type="file" style={{ padding: '10px' }} onChange={(e) => this.handleChangeFiles(e, 'fileIntegridadEXCEL', 'xlsx')} />

                    <Alert severity="info" style={{ textAlign: 'left' }}>
                      <span>
                        * Descargar Formato &nbsp;
                        <a rel="noopener noreferrer" href={Env.UrlFilesPublic + this.state.loadData.files.integridad_contractual} target="_blank">
                          aquí
                        </a>
                      </span>
                    </Alert>
                  </div>
                </Grid>*/}
                <Grid item xs={12} sm={12}>
                  <Alert severity="info" style={{ textAlign: 'left' }}>
                    * El tamaño máximo permitido es de {Env.AllowedSize} megas.
                    <br />
                    * El documento debe ser de extensión .PDF
                    <br />
                  </Alert>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <p style={{ fontStyle: 'italic' }}>Los campos marcados con (*) son obligatorios.</p>
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="secondary" size="large" startIcon={<Icon>check</Icon>} style={{ margin: '10px' }}>
                  Radicar
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>

        <Dialog onClose={this.handleCloseDialog} aria-labelledby="customized-dialog-title" fullWidth={true} maxWidth="xl" open={this.state.openDialog}>
          <GeneracionDireccion onClose={this.handleCloseDialog} setDireccion={this.setDireccion} currentKey={this.state.currentKey} tipoZona="U" />
        </Dialog>
      </div>
    );
  }
}

export default withRouter(InscripcionProveedores);
